import './SectionSupport.scss';

import { CopyToClipboardButton } from '../../CopyToClipboardButton';
import QuickLinkSection from '../QuickLinkSection';

export const SectionSupport = () => (
  <QuickLinkSection subtitle="Questions? Get in touch!" title="Support">
    <div>
      <a href="mailto:partnersupport@engine.tech">partnersupport@engine.tech</a>
    </div>
    <CopyToClipboardButton
      buttonProps={{
        className: 'quick-links-support-copy-to-clipboard-button',
        outlined: true,
      }}
      copyData="partnersupport@engine.tech"
    >
      Copy Email
    </CopyToClipboardButton>
  </QuickLinkSection>
);
